import { useQuery } from '@rocicorp/zero/react'
import { formatCents, formatTime } from '../../lib/format.ts'
import { queries } from '../../zero/queries.ts'
import { PagedSection, usePagedLimit } from './PagedSection.tsx'

/**
 * Every credit, used or not. A credit may be consumed partially (US-16), so the
 * remaining amount is shown separately whenever it differs from the original.
 */
export function CreditHistory({ userId }: { userId: string }) {
  const { limit, showMore } = usePagedLimit()
  const [credits, result] = useQuery(queries.creditHistoryForUser({ userId, limit }))

  return (
    <PagedSection
      title="Credits"
      shown={credits.length}
      limit={limit}
      showMore={showMore}
      complete={result.type === 'complete'}
      emptyText="No credits recorded."
    >
      {credits.map((credit) => {
        const used = credit.usedAt != null
        const partlyUsed = !used && credit.remainingAmountCents < credit.amountCents
        return (
          <div className="line" key={credit.id}>
            <div className="line-main">
              <div className="line-title">
                {credit.paymentId ? 'Overpayment credit' : 'Manual credit'}
                <span className={`pill-tag ${used ? '' : 'pill-tag--credit'}`}>
                  {used ? 'Fully used' : partlyUsed ? 'Partly used' : 'Available'}
                </span>
                {credit.description ? (
                  <span className="muted"> · {credit.description}</span>
                ) : null}
              </div>
              <div className="line-sub">
                {formatTime(credit.createdAt)}
                {used ? ` · used ${formatTime(credit.usedAt)}` : ''}
                {partlyUsed ? ` · ${formatCents(credit.remainingAmountCents)} remaining` : ''}
              </div>
            </div>
            <span className="line-amount">{formatCents(credit.amountCents)}</span>
          </div>
        )
      })}
    </PagedSection>
  )
}
